import React from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import { formLabelCss } from '../../legacy-design-system/text'
import { Row, Box } from '../../legacy-design-system/form'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { MultiSelectCombobox } from '../../legacy-design-system/combobox/multi-select-combobox'
import { formatStyles } from '../react-intl-helpers'

interface Props {
  readonly onKeywordsChange: (keywords: string[]) => void
  readonly customKeywords: string[]
}

export function CustomKeywordsForm({
  onKeywordsChange,
  customKeywords
}: Props) {
  const intl = useIntl()
  return (
    <Row>
      <Box basis={8}>
        <MultiSelectCombobox<string>
          customComboboxInputTestID="sensitive-data-edit-form-keywords-input"
          placeHolderText={intl.formatMessage({
            id: 'action_enterKeywords'
          })}
          renderLabel={() => {
            return (
              <div
                className={css`
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                `}
              >
                <div
                  className={cx(
                    formLabelCss,
                    css`
                      margin-right: auto;
                      padding-bottom: 3px;
                    `
                  )}
                >
                  {intl.formatMessage({
                    id: 'title_customKeywords'
                  })}
                </div>
                <div
                  className={css`
                    font-size: 12px;
                    color: ${theme.color.neutral60};
                  `}
                >
                  {intl.formatMessage(
                    {
                      id: 'action_enterToAddNewAKeyword'
                    },
                    {
                      ...formatStyles.italic
                    }
                  )}
                </div>
              </div>
            )
          }}
          values={customKeywords}
          onChange={(keywords: string[]) => {
            onKeywordsChange(keywords)
          }}
          items={[]}
          createMessage={{
            id: 'action_add'
          }}
          tagExistsTranslationID="title_keywordAlreadyExists"
          onNewItemClick={() => undefined}
          itemFromInput={(inputValue) => inputValue}
          itemsEqual={(a, b) => a === b}
          isAddAllowed
        />
      </Box>
    </Row>
  )
}
